<mat-list *ngIf="menuNo == 1">
    <h3 mat-subheader>Create</h3>
    <mat-list-item>
        <mat-icon mat-list-icon>folder</mat-icon>
        <h4 mat-line>Activity</h4>

    </mat-list-item>
    <mat-list-item>
        <mat-icon mat-list-icon>folder</mat-icon>
        <h4 mat-line>Opportunity</h4>

    </mat-list-item>
    <mat-list-item>
        <mat-icon mat-list-icon>folder</mat-icon>
        <h4 mat-line>Topic</h4>

    </mat-list-item>
    <mat-list-item>
        <mat-icon mat-list-icon>folder</mat-icon>
        <h4 mat-line>Contact</h4>

    </mat-list-item>

</mat-list>
<mat-list *ngIf="menuNo == 2">
    <h3 mat-subheader>Create</h3>
    <mat-list-item>
        <mat-icon mat-list-icon>folder</mat-icon>
        <h4 mat-line>Approve</h4>

    </mat-list-item>
    <mat-list-item>
        <mat-icon mat-list-icon>folder</mat-icon>
        <h4 mat-line>Reject</h4>

    </mat-list-item>


</mat-list>

<mat-list class="m-l--16 m-r--16" *ngIf="menuNo.menuNo == 3">

    <div fxLayout="row wrap" class="footer-menu menu-in-bs">
        <div matRipple matRippleRadius="30" matRippleCentered="true" matRippleUnbounded="true" fxFlex="20"
            (click)="openLink($event)" routerLink="/project-setting/gallery" [queryParams]="{ID:menuNo.ID}">
            <mat-icon class="footer-icon">image</mat-icon>
            <div class="footer-title">gallery</div>
        </div>

        <div matRipple matRippleRadius="30" matRippleCentered="true" matRippleUnbounded="true" fxFlex="20"
            (click)="openLink($event)" routerLink="/project-setting/unit" [queryParams]="{ID:menuNo.ID}">
            <mat-icon class="footer-icon">select_all</mat-icon>
            <div class="footer-title">units</div>
        </div>

        <div matRipple matRippleRadius="30" matRippleCentered="true" matRippleUnbounded="true" fxFlex="20"
            (click)="openLink($event)" routerLink="/project-setting/sales-chart" [queryParams]="{ID:menuNo.ID}">
            <mat-icon class="footer-icon ">gavel</mat-icon>
            <div class="footer-title ">sales chart</div>
        </div>

        <div matRipple matRippleRadius="30" matRippleCentered="true" matRippleUnbounded="true" fxFlex="20"
            (click)="openLink($event)" routerLink="/project-setting/brochure" [queryParams]="{ID:menuNo.ID}">
            <mat-icon class="footer-icon">import_contacts</mat-icon>
            <div class="footer-title">brochure</div>
        </div>

        <div matRipple matRippleRadius="30" matRippleCentered="true" matRippleUnbounded="true" fxFlex="20"
            (click)="openLink($event)" routerLink="/project-setting/policy-detail" [queryParams]="{ID:menuNo.ID}">
            <mat-icon class="footer-icon">assignment_turned_in</mat-icon>
            <div class="footer-title">Policy</div>
        </div>

    </div>

    <div fxLayout="row wrap" class="footer-menu menu-in-bs m-t-10">
        <div matRipple matRippleRadius="30" matRippleCentered="true" matRippleUnbounded="true" fxFlex="20"
            (click)="openLink($event)">
            <mat-icon class="footer-icon">email</mat-icon>
            <div class="footer-title">Email</div>
        </div>
        <div matRipple matRippleRadius="30" matRippleCentered="true" matRippleUnbounded="true" fxFlex="20"
            (click)="openLink($event)"  routerLink="/project-setting/banker-list" [queryParams]="{ID:menuNo.ID}">
            <mat-icon class="footer-icon">account_balance</mat-icon>
            <div class="footer-title">Panel EF</div>
        </div>
    </div>
</mat-list>